import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';
import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { filter, map, Observable } from 'rxjs';

@Injectable()
export class MonitoringRouteGuard implements CanActivate, CanActivateChild {

    constructor(
        private currentUserState: CurrentUserStateService,
        private router: Router
    ) {}

    canActivate(): Observable<boolean> {
        return this.checkAdvancedMonitoringPermission();
    }

    canActivateChild(): Observable<boolean> {
        return this.checkAdvancedMonitoringPermission();
    }

    private checkAdvancedMonitoringPermission(): Observable<boolean> {
        return this.currentUserState.getPermissions().pipe(
            filter(x => x !== null),
            map(permissions => {
                if (permissions.includes(userPermissionsEnum.advancedMonitoring)) {
                    return true;
                }
                this.router.navigate(['Dashboard']);
                return false;
            })
        );
    }
}
